import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Checkbox } from "../../../../../../Inputs";
import { Number } from "../../../../../../Inputs/react-hook-form";
import { SelectedSubmissionsBuilderField } from "../../reducer";
import {
  SubmissionsBuilderFieldSettings,
  SubmissionsBuilderFormDataStructure,
} from "../../types";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import {
  DisplaySettingsSection,
  FieldPermissionsConfig,
  FieldSettingConfig,
} from "./shared";

const PropertyMarketFieldSettings = ({
  fieldPath,
  isModuleInput,
  readOnly,
}: SelectedSubmissionsBuilderField & SubmissionsBuilderFieldSettings) => {
  const { setValue, register, watch } =
    useFormContext<SubmissionsBuilderFormDataStructure>();

  const startingEnumValue = watch(`${fieldPath}.enum`);

  const [checked, setChecked] = useState(
    startingEnumValue?.includes("squareFootageEstimate" as any),
  );

  useEffect(() => {
    const constantEnumValues = [
      "automatedAssessedValue",
      "otherValueEstimate",
    ] as const;

    if (checked) {
      setValue(
        `${fieldPath}.enum`,
        [...constantEnumValues, "squareFootageEstimate"],
        { shouldValidate: true },
      );
    } else {
      // Have to spread because it's readonly
      setValue(`${fieldPath}.enum`, [...constantEnumValues], {
        shouldValidate: true,
      });
    }
  }, [checked]);

  return (
    <WidgetSettingsContainer>
      <FieldSettingConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isFormulaField={false}
        readOnly={readOnly}
      />
      <Checkbox
        value={checked}
        onChange={setChecked}
        name="includeSquareFootage"
        label="Include Square footage estimate"
        disabled={readOnly}
      />
      {checked && (
        <Number
          register={register}
          name={`${fieldPath}.overrides.squareFootageEstimate.costPerSqft.defaultValue`}
          label="Default cost per sqft ($)"
          disabled={readOnly}
        />
      )}
      <FieldPermissionsConfig fieldPath={fieldPath} />
      <DisplaySettingsSection
        fieldPath={fieldPath}
        isNestedField
        readOnly={readOnly}
      />
    </WidgetSettingsContainer>
  );
};

PropertyMarketFieldSettings.displayName = "PropertyMarketFieldSettings";

export default PropertyMarketFieldSettings;
